module.exports = __webpack_public_path__ + "static/media/search_header.14cd9aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/search_header.png
// module id = 681
// module chunks = 0 1